// Contact.jsx
import React, { useState } from "react";

const API_URL = "https://geoapi2s.s100lab.com";
const API_ASK_URL = API_URL + "/api/geo/service/ask";

const initialState = {
  name: "",
  email: "",
  message: "",
};

export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);
  const [submitting, setSubmitting] = useState(false);
  const [resultMsg, setResultMsg] = useState(null);

  const handleChange = (e) => {
    const { name: field, value } = e.target;
    setState((prev) => ({ ...prev, [field]: value }));
  };

  const clearState = () => setState({ ...initialState });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setResultMsg(null);

    // 간단 검증
    if (!name.trim() || !email.trim() || !message.trim()) {
      setResultMsg({ type: "error", text: "이름, 이메일, 내용을 모두 입력해주세요." });
      return;
    }

    setSubmitting(true);
    try {
      const payload = {
        name,
        email,
        ask: message, // ← API 스펙에 맞춰 message → ask 로 매핑
      };

      const res = await fetch(API_ASK_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      });

      // 2xx 확인
      if (!res.ok) {
        // 서버에서 에러 메시지 반환 시 표시
        let detail = "";
        try {
          const data = await res.json();
          detail = data?.error || data?.message || "";
        } catch (_) {}
        throw new Error(detail || `요청 실패 (status: ${res.status})`);
      }

      // 성공 처리
      clearState();
      setResultMsg({ type: "success", text: "문의가 정상적으로 접수되었습니다." });
    } catch (err) {
      setResultMsg({
        type: "error",
        text: `전송 중 오류가 발생했습니다. ${err.message || ""}`,
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>문의하기</h2>
                <p>
                  DOHC와 선회반경 관련하여 API 및 데이터 관련하여 문의 사항이 있을 시 아래에 제공하고 있는 이름, 이메일, 내용을 작성해서 보내주시면 관련 문의에 대해서 답변을 해드리겠습니다.
                </p>
              </div>

              {/* 결과 메시지 */}
              {resultMsg && (
                <div
                  className={`alert ${
                    resultMsg.type === "success" ? "alert-success" : "alert-danger"
                  }`}
                  role="alert"
                >
                  {resultMsg.text}
                </div>
              )}

              <form name="sentMessage" noValidate onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Name"
                        required
                        value={name}
                        onChange={handleChange}
                        disabled={submitting}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                        required
                        value={email}
                        onChange={handleChange}
                        disabled={submitting}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder="Message"
                    required
                    value={message}
                    onChange={handleChange}
                    disabled={submitting}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>

                <div id="success"></div>
                <button
                  type="submit"
                  className="btn btn-custom btn-lg"
                  disabled={submitting}
                >
                  {submitting ? "전송 중..." : "문의 보내기"}
                </button>
              </form>
            </div>
          </div>

          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>담당자 정보</h3>
              <p>
                <span>
                  <i className="fa fa-phone"></i> 연락처
                </span>{" "}
                {props.data ? props.data.phone : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> 이메일
                </span>{" "}
                {props.data ? props.data.email : "loading"}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div id="footer">
        <div className="container text-center">
          <p>&copy; COPYRIGHT 2025 BY GEOSTORY. ALL RIGHTS RESERVED.</p>
        </div>
      </div>
    </div>
  );
};
